import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faClipboard } from '@fortawesome/free-regular-svg-icons/faClipboard';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ThemeType } from '../theme/Theme';
import { AtiraToast } from '../utils/AtiraToast';
import { Tooltip, TooltipProps } from '../utils/local-antd';
import { Button } from './Button';

type CopyButtonProps = {
  copy: string;
  text?: string;
  icon?: IconProp;
  iconSize?: SizeProp;
  color?: keyof ThemeType;
  showText?: boolean;
  successText?: string;
} & Partial<TooltipProps>;

export const CopyButton: React.FC<CopyButtonProps> = ({
  copy,
  text,
  icon,
  iconSize,
  color,
  showText = false,
  successText,
  ...props
}) => {
  const { t } = useTranslation();

  const onCopy = () => {
    navigator.clipboard.writeText(copy);
    AtiraToast.success(t(successText || 'common.copySuccess'));
  };

  return (
    <Tooltip title={text || t('common.copy')} {...props}>
      <Button
        onClick={onCopy}
        backgroundColor="transparent"
        icon={icon || faClipboard}
        iconWidth={iconSize || 'xl'}
        color={color || 'iconPrimary'}
      >
        {showText ? t('common.copy') : null}
      </Button>
    </Tooltip>
  );
};
